<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="基础信息" name="base">
        <el-form
          :disabled="disabledMode"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="子账号名" prop="userName">
            <el-input
              :disabled="actionType === 2"
              v-model="ruleForm.userName"
              placeholder="请输入账号（最长20位中文字母数字符号组合）"
            ></el-input>
          </el-form-item>
          <el-form-item label="角色" prop="roleId">
            <el-select
              filterable
              style="width:100%"
              v-model="ruleForm.roleId"
              placeholder="请选择角色"
            >
              <el-option
                :label="item.roleName"
                :value="item.roleId"
                v-for="(item, index) in roleList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="密码"
            :prop="ruleForm.userId === '-1' ? 'password' : 'passwordM'"
          >
            <el-input
              placeholder="请输入8-16位字母或数字组合"
              autocomplete="new-password"
              v-model="ruleForm.password"
              onfocus="this.type='password'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="确认密码"
            :prop="ruleForm.userId === '-1' ? 'password2' : 'password2M'"
          >
            <el-input
              placeholder="请输入8-16位字母或数字组合"
              onfocus="this.type='password'"
              v-model="ruleForm.password2"
              autocomplete="new-password"
            ></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="fullName">
            <el-input
              v-model="ruleForm.fullName"
              placeholder="请输入真实姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="phone">
            <el-input
              v-model.trim="ruleForm.phone"
              placeholder="请输入账号使用者联系方式"
            ></el-input>
          </el-form-item>
          <el-form-item label="部门" prop="department">
            <el-input
              v-model="ruleForm.department"
              placeholder="请输入账号使用者所属部门"
            ></el-input>
          </el-form-item>
          <el-form-item label="职位" prop="position">
            <el-input
              v-model="ruleForm.position"
              placeholder="请输入账号使用者所属职位"
            ></el-input>
          </el-form-item>
          <el-form-item style="text-align:right">
            <el-button type="primary" @click="submitForm('ruleForm')">
              确认{{ typeText }}
            </el-button>
            <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
            <el-button @click="finishAction(0)">取消</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="权限" name="rights">
        <div>
          <div>一个项目的项目权限仅可分配给一个子账号使用</div>
          <div style="max-height:360px;overflow-y:auto">
            <table-render
              ref="tableRender"
              :config="config"
              rowKey="projectNo"
              :hidePagination="true"
              @selection-change="selectionChange"
            />

            <!-- <el-tree
              :check-strictly="false"
              node-key="projectId"
              ref="projectTree"
              :default-expand-all="true"
              :data="projectRightsGetter"
              :props="propsProject"
              show-checkbox
              @check="projectTreeChange"
              @check-change="projectTreeCheckChange"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span>{{ node.label }}</span>
                <span>{{ data.userName }}</span>
              </span>
            </el-tree> -->
          </div>
          <!-- <div
            v-if="
              projectRights.length > 5 && 5 * pageSize < projectRights.length
            "
            style="cursor:pointer;text-align:right;color:#409EFF;margin:20px"
            @click="pageSize++"
          >
            加载更多
          </div> -->
        </div>
        <div>
          <div>下列权限可重复分配给不同子账号使用</div>
          <div style="max-height:240px;overflow-y:auto">
            <el-tree
              ref="othersTree"
              node-key="menuId"
              :default-expand-all="true"
              :data="othersRights"
              :props="props"
              show-checkbox
              @check-change="othersTreeChange"
            ></el-tree>
          </div>
          <div style="text-align:right;margin:40px 0 20px 0">
            <el-button type="primary" @click="userProjectAddOrEditSubmit">
              确认{{ typeText }}
            </el-button>
            <el-button @click="finishAction(0)">取消</el-button>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import tableRender from '@/components/tableRender';
import { accountManagement } from '@/api/ajax';
import { authAction as config } from './config';

export default {
  components: {
    tableRender
  },
  props: {
    actionType: {
      type: Number,
      require: true
    },
    userId: {
      type: [Number, String],
      require: true
    },
    defaultValue: {
      type: Object,
      require: false
    }
  },
  data() {
    var validUserName = (rule, value, callback) => {
      var reg = /[^\u4e00-\u9fa5A-Za-z0-9_{}()（）【】[\]-]/;
      if (reg.test(value)) {
        callback(new Error('请输入中文、英文、数字、下划线、横线、括号'));
      } else {
        callback();
      }
    };
    var validUserPhone = (rule, value, callback) => {
      let reg = /^[0-9]{11}$/;
      if (!reg.test(value)) {
        callback(new Error('请输入有效的手机号'));
      } else {
        callback();
      }
    };
    var validatePassM = (rule, value, callback) => {
      if (this.ruleForm.password === '') {
        callback();
      } else {
        if (
          this.ruleForm.password.length < 8 ||
          this.ruleForm.password.length > 16
        ) {
          callback(new Error('请输入8-16位字母或数字组合'));
        } else {
          callback();
        }
      }
    };
    var validatePass = (rule, value, callback) => {
      value = this.ruleForm.password2;
      if (!value) {
        value = '';
      }
      if (value === '' && this.actionType === 1) {
        callback(new Error('请再次输入密码'));
      } else if (value != this.ruleForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      config,
      pageSize: 1,
      propsProject: {
        label: 'projectName',
        children: 'children',
        disabled: this.projectTreeDisabled
      },
      props: {
        children: 'list',
        label: 'menuName'
      },
      activeName: 'base',
      projectTreeSelected: new Set(),
      othersTreeSelected: new Set(),
      ruleForm: {
        type: 2,
        userName: '',
        roleId: '',
        password: '',
        fullName: '',
        phone: '',
        department: '',
        position: '',
        userId: '-1'
      },
      roleList: [],
      rules: {
        userName: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          { max: 20, message: '最长20位中文字母数字符号组合', trigger: 'blur' },
          { validator: validUserName, trigger: 'blur' }
        ],
        roleId: [{ required: true, message: '请选择角色', trigger: 'change' }],
        fullName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          {
            max: 10,
            message: '姓名不能超过10个字符',
            trigger: 'blur'
          }
        ],
        passwordM: [
          {
            validator: validatePassM,
            trigger: 'blur'
          },
          {
            min: 8,
            max: 16,
            message: '请输入8-16位字母或数字组合',
            trigger: 'blur'
          }
        ],
        phone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
          { validator: validUserPhone, trigger: 'blur' },
          {
            max: 11,
            message: '不能超过11个字符',
            trigger: 'blur'
          }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            min: 8,
            max: 16,
            message: '请输入8-16位字母或数字组合',
            trigger: 'blur'
          }
        ],
        department: [
          {
            max: 10,
            message: '不能超过10个字符',
            trigger: 'blur'
          }
        ],
        position: [
          {
            max: 10,
            message: '不能超过10个字符',
            trigger: 'blur'
          }
        ],
        password2M: [
          {
            min: 8,
            max: 16,
            message: '请输入8-16位字母或数字组合',
            trigger: 'blur'
          },
          {
            validator: validatePass,
            trigger: 'blur'
          }
        ],
        password2: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          {
            min: 8,
            max: 16,
            message: '请输入8-16位字母或数字组合',
            trigger: 'blur'
          },
          {
            validator: validatePass,
            trigger: 'blur'
          }
        ]
      },
      isMounted: false,
      othersRights: [],
      projectRights: [],
      backupSelected: ''
    };
  },
  watch: {
    tableData: function(value) {
      if (value.length && this.projectTreeSelected.length === 0) {
        this.$refs.tableRender.$refs.table.tableData.map(item => {
          if (item.flag === 1 && item.userId === this.userId) {
            this.projectTreeSelected.push(item);
          }
        });
        this.$refs.tableRender.$refs.table.store.states.selection = this.projectTreeSelected;
      }
    },
    activeName: function(value) {
      if (value === 'rights' && this.ruleForm.userId === '-1') {
        this.$message.error('请先完善基础信息');
        this.$nextTick(() => {
          this.activeName = 'base';
        });
      }
    }
  },
  computed: {
    tableData() {
      if (this.isMounted) {
        return this.$refs.tableRender.$refs.table.tableData;
      }
      return null;
    },
    typeText() {
      if (this.actionType === 1) {
        return '创建';
      } else {
        return '修改';
      }
    },
    disabledMode() {
      return this.actionType === 1 && this.ruleForm.userId !== '-1';
    }
  },
  mounted() {
    this.isMounted = true;
    this.pageInit();
    this.getRoleList();
    this.getRightsList();
  },
  methods: {
    projectTreeDisabled(data) {
      return data.userId && data.userId !== this.userId;
    },
    finishAction(type) {
      if (!type) {
        this.$xrkDialog.remove();
      }
    },
    pageInit() {
      this.$set(this.ruleForm, 'userId', this.userId);
    },
    othersTreeChange(othersData, isChecked) {
      if (!othersData.menuId) {
        return;
      }
      if (isChecked) {
        this.othersTreeSelected.add(othersData.menuId);
      } else {
        this.othersTreeSelected.delete(othersData.menuId);
      }
    },
    // checkAllProjectTree(type) {
    //   if (type) {
    //     this.projectRights.map(item => {
    //       this.projectTreeSelected.add(item.projectId);
    //     });
    //   } else {
    //     this.projectTreeSelected.clear();
    //   }
    // },
    selectionChange(e) {
      this.projectTreeSelected = e;
    },
    // projectTreeCheckChange(projectData, isChecked) {
    //   if (!projectData.projectId) {
    //     return;
    //   }
    //   if (isChecked) {
    //     this.projectTreeSelected.add(projectData.projectId);
    //   } else {
    //     this.projectTreeSelected.delete(projectData.projectId);
    //   }
    // },
    // projectTreeChange(projectData, checkedData) {
    //   if (projectData.mainNode) {
    //     if (checkedData.checkedNodes.some(item => item.mainNode)) {
    //       this.checkAllProjectTree(1);
    //     } else {
    //       this.checkAllProjectTree(0);
    //     }
    //     return;
    //   }
    // },
    handleClick() {},
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          accountManagement
            .theNewAccountOrEdit({ ...this.ruleForm })
            .then(res => {
              if (res.pdata.userId) {
                this.ruleForm.userId = res.pdata.userId;
                sessionStorage.setItem('currentUserId', this.ruleForm.userId);
              }
              this.$message.success(`${this.typeText}成功`);
              this.activeName = 'rights';
              this.$emit('confirm');
            });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    getRoleList() {
      accountManagement
        .subaccountManagementRoleList({ type: 2, pageNo: 1, pageSize: 9999 })
        .then(response => {
          this.roleList = response.pdata.list;
        });
    },
    getRightsList() {
      this.projectTreeSelected = [];
      accountManagement
        .userProjectQuery({ type: 2, userId: this.ruleForm.userId })
        .then(res => {
          this.ruleForm = { ...this.ruleForm, ...res.pdata.user };
          this.othersRights = res.pdata.limitsOfAuthorityTwo;
          // this.projectRights = res.pdata.limitsOfAuthorityOne;
          this.othersRights.map(item => {
            item.list.map(k => {
              if (k.flag === 1) {
                this.othersTreeSelected.add(k.menuId);
              }
            });
          });
          this.$refs.othersTree.setCheckedKeys(this.othersTreeSelected);
        });
    },
    userProjectAddOrEditSubmit() {
      let projectParams = [];
      this.projectTreeSelected.map(item => {
        projectParams.push({
          projectId: item.projectId,
          projectType: item.projectType
        });
      });
      accountManagement
        .userProjectAddOrEdit({
          actionType: this.actionType,
          projectTypeVos: projectParams,
          menuIds: [...this.othersTreeSelected],
          type: 2,
          userId: this.ruleForm.userId
        })
        .then(() => {
          this.$message.success(`${this.typeText}成功`);
          this.$emit('confirm');
          this.$xrkDialog.remove();
        });
    }
  }
};
</script>

<style></style>
